import { Market } from "@config/site/types";

const postalCodeCA = /^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/;
const postalCodeUS = /^\d{5}(-\d{4})?$/;

/**
 * @description (Czech Republic)
 * 5 digits. Allow space after 3rd digits.
 * Valid: 12345, 123 45
 * Invalid: 1234 (too short), 123456 (too long), 12 345 (incorrect space placement)
 */
const postalCodeCZ = /^\d{3}\s?\d{2}$/;
const postalCodeJP = /^\d{7}$/;
const postalCodeAU = /^\d{4}$/;
const postalCodeNZ = /^\d{4}$/;
const postalCodeCY = /^\d{4}$/;
const postalCodeIN = /^[1-9]\d{5}$/;
const postalCodeEE = /^\d{5}$/;
const postalCodeES = /^\d{5}$/;
const postalCodeKR = /^\d{5}$/;
const postalCodeMY = /^\d{5}$/;
const postalCodeSG = /^\d{6}$/;
const postalCodeHU = /^[1-9]\d{3}$/;
const postalCodeDE = /^\d{5}$/;
const postalCodeAT = /^\d{4}$/;
const postalCodeNL = /^[1-9]\d{3} ?[A-Z]{2}$/;
const postalCodeCH = /^[1-9]\d{3}$/;
const postalCodePL = /^(\d{2})[-](\d{3})$/;
const postalCodeDK = /^\d{4}$/;
const postalCodePT = /^[1-9]\d{3}((-)\d{3})$/;
const postalCodeHR = /^[1-5]\d{4}$/;
const postalCodeBE = /^\d{4}$/;
const postalCodeFR = /^\d{5}$/;
const postalCodeSI = /^[1-9]\d{3}$/;
const postalCodeSK = /^(?:\d{3} \d{2}|\d{5})$/;
const postalCodeFI = /^\d{5}$/;
const postalCodeLT = /^((LT)[-])?(\d{5})$/;
const postalCodeLV = /^((LV)[-])?(\d{4})$/;
const postalCodeNO = /^\d{4}$/;
const postalCodeSE = /^[1-9]\d{2} \d{2}$/;

export const postalCodeRegex: Record<Market, RegExp | null> = {
    [Market.CZ]: postalCodeCZ,
    [Market.CA]: postalCodeCA,
    [Market.US]: postalCodeUS,
    [Market.JP]: postalCodeJP,
    [Market.AU]: postalCodeAU,
    [Market.NZ]: postalCodeNZ,
    [Market.CY]: postalCodeCY,
    [Market.IN]: postalCodeIN,
    [Market.EE]: postalCodeEE,
    [Market.ES]: postalCodeES,
    [Market.KR]: postalCodeKR,
    [Market.MY]: postalCodeMY,
    [Market.SG]: postalCodeSG,
    [Market.HU]: postalCodeHU,
    [Market.DE]: postalCodeDE,
    [Market.AT]: postalCodeAT,
    [Market.NL]: postalCodeNL,
    [Market.CH]: postalCodeCH,
    [Market.PL]: postalCodePL,
    [Market.DK]: postalCodeDK,
    // GB uses a custom function for comparisson because it's easier than regex
    [Market.GB]: null,
    [Market.PT]: postalCodePT,
    [Market.HR]: postalCodeHR,
    [Market.BE]: postalCodeBE,
    [Market.FR]: postalCodeFR,
    [Market.SI]: postalCodeSI,
    [Market.SK]: postalCodeSK,
    [Market.FI]: postalCodeFI,
    // IE has a very complex regex, but since it's a small market and we haven't had issues yet we just use basic yup validation for now
    [Market.IE]: null,
    [Market.LT]: postalCodeLT,
    [Market.LV]: postalCodeLV,
    [Market.NO]: postalCodeNO,
    [Market.SE]: postalCodeSE,
};
